import { render } from "./AddNewMenuModifier.vue?vue&type=template&id=89fc6e6c&scoped=true"
import script from "./AddNewMenuModifier.vue?vue&type=script&lang=js"
export * from "./AddNewMenuModifier.vue?vue&type=script&lang=js"

import "./AddNewMenuModifier.vue?vue&type=style&index=0&id=89fc6e6c&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89fc6e6c"]])

export default __exports__